import {Text, TouchableOpacity, View} from "react-native";
import {FONT_SIZE, THEME_COLORS} from "../styles";
import React from "react";
import {Dropdown} from "./index";

export interface IModalViewProps {
    show: boolean;
    children: JSX.Element;
    onClose: () => void;
    headerContent: JSX.Element;
    size?: "small" | "medium" | "large";
    headerStyle?: any
}

const getWidthHeightForSize = (size: string) => {
    let height = '85vh';
    let width = '90vw';
    if (size == "small") {
        height = '65vh';
        width = '45vw'
    } else if (size == "medium") {
        height = '70vh';
        width = '75vw';
    }
    return {
        height,
        width

    }
};

export const ModalView = (props: IModalViewProps) => {
    const {show, onClose, headerContent} = props;
    if (!show) return null;
    const size = getWidthHeightForSize(props.size);

    return <Dropdown show={show} onClose={onClose} parentRef={null}>
        <View style={{
            backgroundColor: THEME_COLORS.bgWhite,
            // position: 'relative',
            height: size.height,
            width: size.width,
            borderRadius: 12,
            flexDirection: "column"
        }}>
            <View style={[{
                width: '100%',
                flexDirection: "row",
                backgroundColor: THEME_COLORS.primary,
                minHeight: '6.5vh',
                borderTopRightRadius: 12,
                borderTopLeftRadius: 12,
                alignItems: 'center',
                paddingHorizontal: 30
            }, props.headerStyle]}>
                <View style={{flexDirection: "row", alignItems: 'center'}}>
                    {headerContent}
                </View>
                <View style={{flex: 1}}></View>
                <TouchableOpacity
                    onPress={onClose}
                >
                    <Text style={{
                        color: THEME_COLORS.white,
                        fontWeight: "bold",
                        fontSize: FONT_SIZE.tabFontSize
                    }}>X</Text>
                </TouchableOpacity>
            </View>
            {props.children}
        </View>
    </Dropdown>
};